import { compressedUrl } from "@/utils/string";
import {
  Box,
  Center,
  Divider,
  Flex,
  Image,
  Link,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Text,
  chakra,
  PopoverArrow,
} from "@chakra-ui/react";
import config from "@/config";
import { QrCodeIcon } from "@/components/Icons";
const links = [
  {
    title: "产品服务",
    links: [
      {
        title: "图宇宙",
        link: "https://www.nolibox.com/introduction",
      },
      {
        title: "图宇宙企业版",
        link: "https://qiye.nolibox.com/",
      },
      {
        title: "画宇宙",
        link: "https://creator.nolibox.com",
      },
      // {
      //   title: "画宇宙 Open API 平台",
      //   link: "https://open.creator.nolibox.com/",
      // },
      // {
      //   title: "LogoLuck",
      //   link: "https://www.logoluck.com",
      // },
    ],
  },
  {
    title: "商务合作",
    links: [
      {
        title: "邮箱：official@nolibox.com",
        link: "mailto:official@nolibox.com",
      },
      {
        title: (
          <Text>
            商务/销售微信：微信扫码
            <Popover placement="right" trigger="hover" offset={[0, 10]}>
              <PopoverTrigger>
                <chakra.span>
                  <QrCodeIcon />
                </chakra.span>
              </PopoverTrigger>
              <PopoverContent
                w="100px"
                border="none"
                bg="white"
                boxShadow="0px 0px 12px rgba(0, 0, 0, 0.15)"
              >
                <Image src="http://nolipix-js.nolibox.com/assets/creator/business/contact_qrcode_wechat.png" />
              </PopoverContent>
            </Popover>
          </Text>
        ),
        link: "",
      },

      // {
      //   title: (
      //     <Text>
      //       生态合作微信：noliboxljs
      //       <Popover placement="right" trigger="hover" offset={[0, 10]}>
      //         <PopoverTrigger>
      //           <chakra.span>
      //             <QrCodeIcon />
      //           </chakra.span>
      //         </PopoverTrigger>
      //         <PopoverContent
      //           w="100px"
      //           border="none"
      //           bg="white"
      //           boxShadow="0px 0px 12px rgba(0, 0, 0, 0.15)">
      //           <Image src="http://nolipix-js.nolibox.com/assets/creator/business/qr_channel.png" />
      //         </PopoverContent>
      //       </Popover>
      //     </Text>
      //   ),
      //   link: "",
      // },
      // {
      //   title: "生态合作电话：180 1016 7386",
      //   link: "",
      // },
      {
        title: "公司地址：北京市海淀区五道口东升大厦A座",
        link: "",
      },
    ],
  },
  {
    title: "客服和维保响应",
    links: [
      {
        title: "邮箱：support@nolibox.com",
        link: "mailto:support@nolibox.com",
      },
      {
        title: (
          <Text>
            维保响应：微信扫码
            <Popover placement="right" trigger="hover" offset={[0, 10]}>
              <PopoverTrigger>
                <chakra.span>
                  <QrCodeIcon />
                </chakra.span>
              </PopoverTrigger>
              <PopoverContent
                w="100px"
                border="none"
                bg="white"
                boxShadow="0px 0px 12px rgba(0, 0, 0, 0.15)"
              >
                <Image src="http://nolipix-js.nolibox.com/assets/creator/business/contact_qrcode_wechat.png" />
              </PopoverContent>
            </Popover>
          </Text>
        ),
        link: "",
      },
      {
        title: (
          <Text>
            客服微信：微信扫码
            <Popover placement="right" trigger="hover" offset={[0, 10]}>
              <PopoverTrigger>
                <chakra.span>
                  <QrCodeIcon />
                </chakra.span>
              </PopoverTrigger>
              <PopoverContent
                w="100px"
                border="none"
                bg="white"
                boxShadow="0px 0px 12px rgba(0, 0, 0, 0.15)"
              >
                <Image src="http://nolipix-js.nolibox.com/assets/creator/business/contact_qrcode_wechat.png" />
              </PopoverContent>
            </Popover>
          </Text>
        ),
        link: "",
      },
    ],
  },
];

function Footer() {
  return (
    <Box p="30px 80px" bg="white">
      <Flex justify="space-between">
        <Flex>
          {links.map((linkData) => {
            return (
              <Box key={linkData.title} mr="70px">
                <Text fontSize="18px" color="#1D2129" fontWeight={600} mb="20px">
                  {linkData.title}
                </Text>
                {linkData.links.map((link, idx) => {
                  return (
                    <Link
                      display="block"
                      color="#4E5969"
                      fontSize="14px"
                      my="6px"
                      key={link.link + idx}
                      href={link.link || "javascript:void(0)"}
                      {...(link.link ? { target: "_blank" } : {})}
                      _hover={{
                        textDecor: link.link ? "underline" : "none",
                      }}
                    >
                      {link.title}
                    </Link>
                  );
                })}
              </Box>
            );
          })}
        </Flex>
        <Flex flexDir="column" align="self-end">
          <Image w="135px" src="http://nolipix-js.nolibox.com/assets/creator/logo_nolibox.png" />
        </Flex>
      </Flex>
      <Divider mt="36px" mb="12px" />
      <Flex justify="space-between" color="#86909C" fontSize="14px">
        <Text>Copyright © 2021-现在 北京计算美学科技有限公司</Text>
        <Flex gap="20px">
          <Text>网信算备 110108210709901230015 号</Text>
          <Text>京 ICP 备 2021032906 号</Text>
        </Flex>
      </Flex>
    </Box>
  );
}

export default Footer;
